import React, { Component } from 'react';
import IconRender from '../std/IconRender';

class ExpandCollapseCriteria extends Component {

    constructor(props) {
        super(props);
        this.state = { isExpanded: false, allExpanded: false };
    }

    expandAll = () => {
        const toExpand = !this.state.allExpanded;
        const collapseElementList = document.querySelectorAll('.collapseCriteria');
        [...collapseElementList].map(collapseEl => {
            if (toExpand) {
                collapseEl.classList.add('show');
            } else {
                collapseEl.classList.remove('show');
            }
            return toExpand;
        });
        const collapseButtonList = document.querySelectorAll('.collapseCriteriaButton');
        [...collapseButtonList].map(collapseEl => {
            if (toExpand) {
                collapseEl.setAttribute('aria-expanded', 'true');
                collapseEl.classList.remove('collapsed');
            } else {
                collapseEl.setAttribute('aria-expanded', 'false');
                collapseEl.classList.add('collapsed');
            }
            return toExpand;
        });
        if (toExpand) {
            this.setState({ isExpanded: true });
        } else {
            this.setState({ isExpanded: false });
        }
        this.setState({ allExpanded: toExpand });
    };

    render() {
        return (
            <button className="btn btn-primary border" type="button" id="expandall" onClick={this.expandAll}>
                {!this.state.isExpanded && <IconRender name="arrows-expand" />}
                {this.state.isExpanded && <IconRender name="arrows-collapse" />}
            </button>
        )
    }
}

export default (ExpandCollapseCriteria);
